const defaultSeparator = ' ';

/**
 * Concatenate the elements of the given string array, but ignores empty, blank and undefined strings,
 * and separates the items by ' ' (space) or a specified separator string.
 * @param {(string | undefined | null)[]} stringArray - The string array to be concatenated
 * @param {string | undefined} [separator=(space)] - The separator string
 * @return {string} -The cleaned, concatenated string
 */
export const joinString = (
	stringArray: (string | undefined | null)[],
	separator?: string
): string => {
	const cleanedStringArray: string[] = [];
	for (let i = 0; i < stringArray.length; i++) {
		const cleanedString = stringArray[i]?.trim?.();
		if (cleanedString) {
			cleanedStringArray.push(cleanedString);
		}
	}
	return cleanedStringArray.join(separator || defaultSeparator);
};
